import dayjs, { Dayjs } from "dayjs";

export default class SalarySimInputPostData {
    message: string = ""; // string
    mode_simul: string = ""; // string
    nom: string = ""; // string
    cd_handicape: number = 0; // int
    cd_etat_civil: number = 0; // int
    cd_conjoint: number = 0; // int
    
    nb_enfants_charge: number = 0; // int
    nb_enfants_handicapes_charge: number = 0; // int
    nb_autres_personnes_charge: number = 0; // int
    nb_autres_personnes_handicapees_charge: number = 0; // int
    nb_autres_personnes_plus65_charge: number = 0; // int
    nb_autres_personnes_plus65_handicapees_charge: number = 0; // int

    cd_type_contrat: number = 0; // int
    cd_temps_plein: number = 0; // int
    
    regime_horaire: Array<number> = new Array<number>(); //int[]
    
    cd_soumis_onss: number = 0; // int
       
    cd_soumis_precompte: number = 0; // int
       
    commission_paritaire: string = ""; // string
    prefixe_onss: string = ""; // string
    cd_effectif_employeur: number = 0; // int

    net: number = 0; // double
    brut: number = 0; // double
    assurance_groupe_empl: number = 0; // double

    commissions: number = 0; // double
    avantages_nature: number = 0; // double
    avantages_nature_voiture: number = 0; // double
    assurance_groupe: number = 0; // double
    divers_net_neg: number = 0; // double

    abonnement_social: number = 0; // double
    frais_deplacement: number = 0; // double
    divers_net_pos: number = 0; // double

    pecule_vacances: number = 0; // double
    simple_pecule_anticipe: number = 0; // double
    double_pecule_anticipe: number = 0; // double
    complement_pecule_anticipe: number = 0; // double
    
    simple_pecule: number = 0; // double
    double_pecule: number = 0; // double
    complement_pecule: number = 0; // double

    prime_fin_annee: number = 0; // double
    remuneration_non_periodique: number = 0; // double

    cd_prest_plus_1: string = ""; // string
    montant_plus_1: number = 0; // double
    cd_prest_plus_2: string = ""; // string
    montant_plus_2: number = 0; // double
    cd_prest_plus_3: string = ""; // string
    montant_plus_3: number = 0; // double 

    // Nouveau champs iSimul
    no_employeur: number = 0; // long
    no_travailleur: number = 0; // long
    no_simulation: number = 0; // long
    no_dossier: number = 0; // long
    agent: string = ""; // string
    cd_reduction_onss: string = ""; // string
    dt_deb_reduction_onss: Date = new Date(); // DateTime
    cd_periodicite_remun: number = 0; // int
    cd_base_remun: number = 0; // int
    no_niveau_1: number = 0; // int
    mt_cot_trav_cheque_repas: number = 0; // double
    mt_cot_empl_cheque_repas: number = 0; // double
    cd_assurance_groupe: number = 0; // int
    cd_regle_assurance_groupe: string = ""; // string
    mt_cot_trav_assurance_groupe: number = 0; // double
    mt_cot_empl_assurance_groupe: number = 0; // double
    prime_fixe_soumise: number = 0; // double
    prime_fixe_non_soumise: number = 0; // double
    prime_ex_mt_soumis: number = 0; // double
    prime_ex_mt_non_soumis: number = 0; // double
    indemnite_rupture: number = 0; // double
    Dt_Debut_Contrat: Date = new Date(); // DateTime
    Dt_Fin_Contrat: Date = new Date(); // DateTime

    memo: string = ""; // string

    //
    Fl_Pecule_Vacances: number = 0; // int
    cd_calcul_compl_dpv: number = 0; // int
    cd_calcul_dpv: number = 0; // int
    cd_calcul_ir: number = 0; // int
    cd_calcul_pfa: number = 0;  // int
    duree_ir: number = 0; // int
    unite_duree_ir: number = 0; // int
    pc_pfa: number = 0; // double

    regime_horaire_emp: Array<number> = new Array<number>(); //int[]

    cd_region_domicile: number = 0; // int

    mois_periode_paie: number = 0; // int
    origine: string = ""; // string

    complement_pecule_vacances: number = 0; // double

    //Nouveau champ Lc le 13/07/2009
    cd_prest_plus_4: string = ""; // string
    montant_plus_4: number = 0; // double
    cd_prest_plus_5: string = ""; // string
    montant_plus_5: number = 0; // double
    cd_prest_plus_6: string = ""; // string
    montant_plus_6: number = 0; // double

    // Lc le 8/06/2011
      Date_Naissance: Dayjs = dayjs(); // DateTime

    // Lc le 19/09/2012
    Sans_Avantage_Domicile_Travail: boolean = false; // bool

    // Lc le 17/05/2013
    Activite_Sportive_Secondaire: boolean = false; // bool

    // Lc le 15/09/2015
    Prime_Fin_Annee_Forem_Soumise: number = 0; // double
    Prime_Fin_Annee_Forem_Non_Soumise: number = 0; // double

    // LC le 24/09/2015
    Montant_Imposable_Pp_Ordinaire: number = 0; // double

    // Lc le 08/10/2015
    Montant_Brut_Soumis_Pp: number = 0; // double

    // Lc le 20/6/2016
    No_Unite_Locale: number = 0; // long
    Cd_Competence: string = ""; // string
    Scenario_1er_Engage: number = 0; // int

    // Lc le 25/10/2016
    cd_conjoint_handicape: number = 0; // int

    // Lc le 20/03/2017
    Droits_Auteur: number = 0; // double

    // Lc le 02/05/2022
    nb_plus65_situation_dependance: number = 0; // int

    //ajouté
    //nb_plus65_situation_dependance_handicape:number=0; 

    


}

